import { useTranslations } from 'next-intl';

import {
  CatInlineNotification,
  CatModal,
  CatIconWarningTriangle,
  CatButton
} from 'components/blocks-components';
import { CsrEvent } from 'services/csr-audit-summary/types';

import { useCsrActions } from './hooks';
import styles from './styles.module.scss';

type ModalProps = {
  csrEvents: CsrEvent[] | null;
  handleClose: () => void;
  modalVisible: boolean;
};

function CsrActionSummaryModal({
  csrEvents,
  modalVisible,
  handleClose
}: Readonly<ModalProps>) {
  const t = useTranslations();
  const { csrActions } = useCsrActions();

  return (
    <CatModal
      heading={t('ACTIONS_BY_CAT_CUSTOMER_CARE_ON_YOUR_BEHALF')}
      headingVariant="title"
      isActive={modalVisible}
      onBlModalClose={handleClose}
      size="md"
    >
      <div className={`${styles['header__subtext']} mb-3`}>
        {t('ACTIONS_ON_YOUR_BEHALF_MODAL_VERBIAGE')}
      </div>

      <CatInlineNotification variant="warning">
        <CatIconWarningTriangle slot="before" />
        <ul className="pb-0 mb-0">
          {csrEvents
            ?.filter((item) => csrActions[item.type] !== undefined)
            .map((csrEvent) => {
              const eventType = csrEvent.type;
              return (
                <li
                  id={eventType}
                  key={`${eventType}-${csrEvent?.date}`}
                  data-testid={eventType}
                >
                  {csrActions[eventType]?.(csrEvent)}
                </li>
              );
            })}
        </ul>
      </CatInlineNotification>

      <div className="mt-3">
        <CatButton
          onClick={handleClose}
          className="ph-4 pv-2"
          variant={'ghost'}
        >
          {t('DISMISS')}
        </CatButton>
      </div>
    </CatModal>
  );
}

export default CsrActionSummaryModal;
